import { AttachmentMock } from '../attachments/types/__mocks__/attachment.mock';
import { DocumentPageType } from '../enums/document-page-type';
import { EnumDocumentType } from '../enums/DocumentType';
import { FieldSource } from '../fields/types/enums/field-source';
import { FieldType } from '../fields/types/enums/field-type';
import type { Field } from '../fields/types/field';
import type { MergeFieldMapObject } from '../fields/types/merge-field-map-object';
import type { ContentLinkBlock } from '../types/content-link';
import type { Document } from '../types/Document';
import type { DocumentAttachment } from '../types/document-attachment';
import type { DocumentPage } from '../types/document-page';
import type { Recipient } from '../types/Recipient';
import type { Video } from '../types/Video';
import type { User } from '../users/types/user';
import { VideoSource } from '../video/types/enums/video-source';
import { ChatCommentMock } from './comment';
import { ContactMock } from './contact';
import { ContentLinkMock } from './content-link';
import { DirectoryMock } from './directory';
import { DirectoryTreeMock } from './directoryTree';
import { DocumentMock } from './document';
import { DocumentAttachmentMock } from './document-attachment';
import { DocumentPageMock } from './document-page';
import { DocumentRevisionsMock } from './document-revision';
import { EditorMock } from './editor';
import { EntityMock } from './entity';
import { RecipientMock } from './recipient';
import { ResourceMock } from './resource';
import { ThemeMock } from './theme';
import { UserMock } from './user';
import { VideoMock } from './video';
import { ProductMock } from './product';

const documentPath = '/img/DealroomContract';
const documentExtenstion = '.png';
export const ids = [
  'sb3d9gpepadszrgnqgcevo',
  '9yjqjur2dlcniv4q1pfyfs',
  'xvp5a4yhsqhwnntuj5prrl',
  'hiqeft6yc89w96zftb7g4',
  '44mgcn0mzvmxsoxhap',
  '14y9ftb9t7xkm4392ltuxg',
  'gbdz6s8gf3wzu6v4l15eao',
  'hywakupwnjwnu9rzp87rrb',
  'f324colbriaycqjm79dyt',
  'ysc11xtwh4gewrjvxuz6at',
  '2s8ifh2sjm7vpq07ga9rna',
  'qjzvvact5xaq1pwrs1lll',
  '4x8sg4sh8zl1hwwhjd7tus',
  'mkvzx3xvqyc584sxln2n8',
  's3bkprl0fz60ct76tzc74',
  'zto75yz4rvdepi6511z3ga',
  'jn5f32ph87ntbhkvl0860c',
  'pvsqtbbz7ueeqnoof0pg89',
  'lw2qt8ubygan0ymijj1z7',
  'qax684ej06wm68qo3jegc',
  'sm939mv3yig1cdldbblb',
  'h6twbc8k2wlolj4c3wozei',
  'nuczdywxz7877wg595k7vg',
  'nhpqgc14bs9tcmcjo86zum',
  'mm58mltnizhfhoot4abfh6',
  'ul02s8oeufweej1159jma',
  'bh11f7fgk4lgzp23fjv0gk',
  'bzxlgrxt4nv0t79x0es129c',
  '8ab6j5sr8txjizepob9ijp',
  'lzhhkl7y0kpp6yo29o9yrf',
  'm91487wrt4qcmwu8z5vajo',
  'sfj7qlwk3s7soy84c24ln',
  'vsbjwsh7jxc6fd5dy97cwq',
  'g1ux7yf2xn98e3dggmaz97',
  '9w94razmj16w21pmla8nrh',
  'i6fzncfry2ft6dlhwum8d',
  'dv0sjswkf6ro8eayg70jj',
  't08vel07iqjhqmibh0r17d',
  'v46yax6nohxav6og4xf4d',
  '0m057evu5myj7uq3ub3jc09',
  'tjb48tek6t8cxdrm09hf59',
  '9o1mwp8dfsdp8jrl41nipi',
  'fo53xw8gpep4f5ay0kwes',
  '0yzipmzv0bsrm5ykfm5v8ma',
  'kf9irjg6fghfxeqxrm9db',
  'cneha907joeu2kbga7x1qh',
  'uqiphyneck85s42i3gwgh',
  '2ve0x2w46y64yv77u8v1b',
  'zkdh412dv3nc69e8tqi5',
  'ri9yfp61k7mtdedrun91vp',
];

export function generateDocumentPage(index: number, pageType: DocumentPageType): DocumentPage {
  return {
    id: ids[index],
    pageNum: index,
    pageType: pageType,
    fields: [],
    cropBoxW: 612,
    pageWidth: 900,
    pageHeight: 900,
    thumbUrl: 'hej',
  };
}

const thumbUrl = '/img/engage.jpg';
export function getVideoMock(videoUrl = 'http://youtube.com/hejhejenvideo', id?: string): Video {
  return {
    id: id,
    editable: true,
    published: false,
    saved: false,
    thumbUrl,
    videoId: null,
    videoTitle: 'Introduction',
    videoType: VideoSource.Youtube,
    videoUrl: videoUrl,
    createdAt: 'Wed Jan 25 2017 16:00:00 GMT-0800',
    usedCount: Math.round(Math.random() * 100),
  };
}

export function getMockedFields(fieldsCount = 3): Field[] {
  const fields: Field[] = [];
  for (let index = 0; index < fieldsCount; index++) {
    fields.push({
      id: ids[index],
      pageId: ids[index],
      documentId: ids[index],
      type: FieldType.Text,
      value: '',
      label: '',
      options: [''],
      createdAt: '2020-01-20T14:57:12.000Z',
      isRequired: false,
      isEditable: true,
      isCollectable: false,
      source: FieldSource.Document,
      position: { top: 100, left: 101, width: 146, height: 15 },
      validationRegex: '',
      validationWarning: '',
      recipientId: null,
    });
  }
  return fields;
}

export function getDocumentMock(documentId: string): Document {
  return {
    id: documentId,
    parentDocumentId: '123abc',
    name: 'Mockument',
    isSigning: true,
    isSigningOrder: false,
    isSelfsign: false,
    type: EnumDocumentType.Sales,
    uniqueId: 123123,
    sender: {
      email: 'joakim.sorensen@getaccept.com',
      name: 'Joakim Sörensen',
      senderId: '123',
      thumbUrl: null,
    },
    pages: [],
    tags: [
      {
        id: 'testTagId1',
        title: 'tag1',
        status: 'active',
      },
    ],
    sendDate: '2020-01-01',
    signDate: '2021-01-01 07:59:00',
    user,
    value: 1000,
    contractStartDate: '2019-11-01',
    contractEndDate: '2020-10-31',
    expirationDate: '2019-11-05 07:59:00',
    recipients: [recipient],
    documentRevisions: [],
  };
}

export const contentLinkMock: ContentLinkBlock = {
  id: '123',
  title: 'Lorem Ipsum',
  description: 'This is a description of the link that we took',
  url: 'http://getaccept.com',
  thumbUrl,
  buttonText: 'Read more',
};

export const fieldMock: Field = {
  id: '123',
  pageId: '1',
  documentId: '1231231',
  isCollectable: false,
  isEditable: true,
  isRequired: false,
  type: FieldType.Text,
  value: '',
  label: 'Fält mot recipient',
  createdAt: '1991-08-18',
  position: {
    left: 298,
    top: 427,
    width: 298,
    height: 51,
  },
  recipientId: null,
  validationRegex: '',
  validationWarning: '',
};

const jonasTest = 'Jonas Test';
export const recipient: Recipient = {
  id: '123',
  fullName: jonasTest,
  firstName: 'Jonas',
  lastName: 'Test',
  email: 'jonas.test@test.com',
  mobile: '073112121',
  phone: '073112121',
  note: '',
  companyName: '',
  companyNumber: '',
  recipientId: '123',
  status: 'signed',
};

const andreasAstrom = 'Andreas Åström';
export const user: User = {
  fullName: andreasAstrom,
  firstName: 'Andreas',
  lastName: 'Åström',
  title: 'Prince of software',
  email: 'andreas.astrom@getaccept.com',
  mobile: '+46736661100',
  phone: '',
  id: '12',
};

export const document: Document = {
  name: '',
  value: 0,
  isSigningOrder: false,
  isSelfsign: false,
  isSigning: true,
  type: '',
  sender: null,
};

export function getUploadedFilePages(startIndex: number): DocumentPage[] {
  const documentPages = [];
  for (let i = 0; i < 5; i++) {
    const page: DocumentPage = generateDocumentPage(
      startIndex + i,
      DocumentPageType.DocumentContent
    );
    page.thumbUrl = `${documentPath}${i + 1}${documentExtenstion}`;
    page.pageHeight = i === 4 ? 215 : 279;
    page.pageWidth = i === 4 ? 279 : 215;
    documentPages.push(page);
    if (i === 4) {
      return documentPages;
    }
  }
}

export const documentAttachmentMock: DocumentAttachment = {
  id: '123',
  restrictAccess: false,
  requireView: false,
  createdAt: '',
  attachment: AttachmentMock.one(),
  accessRecipientList: [recipient],
  previewUrl: '/view/12/34/attachment/56',
  lastView: null,
  lastUpload: null,
};

export const mergeFieldMapObjectMock: MergeFieldMapObject = {
  fieldId: '123',
  document: {
    id: '123123',
    type: 'sales',
    name: 'mockument',
    isSelfsign: false,
    isSigning: true,
    isSigningOrder: false,
    value: 123123,
    sender: {
      email: 'hej@hej.com',
      name: 'neo',
      senderId: '1231231231231',
    },
  },
  recipient: {
    fullName: 'test testsson',
    firstName: 'test',
    lastName: 'testsson',
    email: 'test@hej.com',
    mobile: '070123456',
    companyName: 'Restaurant V',
    companyNumber: '666',
  },
  sender: {
    id: '123123123123123',
    firstName: 'Arne Weise',
    lastName: 'Arne',
    fullName: 'Weise',
    email: 'arne@julafton.se',
    title: 'President of the World',
    mobile: '070999999',
  },
};

export default {
  recipient: RecipientMock,
  user: UserMock,
  document: DocumentMock,
  video: VideoMock,
  documentAttachment: DocumentAttachmentMock,
  documentPage: DocumentPageMock,
  comment: ChatCommentMock,
  entity: EntityMock,
  theme: ThemeMock,
  contentLink: ContentLinkMock,
  resource: ResourceMock,
  directory: DirectoryMock,
  directoryTree: DirectoryTreeMock,
  documentRevision: DocumentRevisionsMock,
  contact: ContactMock,
  editor: EditorMock,
  product: ProductMock,
};
